import { baseStaticUrl } from "../../config";
import { compose, concat, defaultTo } from "ramda";

const buildAvatarSrc = compose(
  concat(`${baseStaticUrl}/assets/avatar/170x170/`),
  defaultTo("0008-cr-orange-black.png")
);

export { buildAvatarSrc };
